import { useEffect, useState } from "react";
import "../styles/updateTournament.css";
import { API_CONFIG } from "../config/api";
import { generateAuthToken,generateURN } from "./hmac";

const UpdateTournament = () => {
  const [tournaments, setTournaments] = useState([]);
  const [selected, setSelected] = useState(null); 
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const fetchTournaments = async () => {
    try {
      const {host,fetchTournaments,basic}=API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn);
      setLoading(true);
      setMsg("");

      const res = await fetch(
        `https://${host}${fetchTournaments.path}`,
        {
          method: fetchTournaments.method,
          credentials: "include", 
          headers:{
             Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
             urn:urn,
             authToken:authToken,
           }
        } 
      );

      const data = await res.json();
      const list = data?.apiResponseData?.responseData?.tournaments || [];
      setTournaments(list);
    } catch (err) {
      setMsg("Failed to fetch tournaments: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTournaments();
  }, []);

  const handleSelect = (t) => {
    setSelected(t);
    setMsg("");
  };

  const closePopup = () => setSelected(null);

  const updateActiveStatus = async (newActive) => {
    if (!selected?.tournamentID) return;

    try {
      const {host,updateTournament,basic}=API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn,"admin");
      setLoading(true);
      setMsg("");
      const url = `https://${host}${updateTournament.path(selected.tournamentID)}`;
      const res = await fetch(url, {
        method: updateTournament.method,
        credentials: "include",
        headers: {
           "Content-Type": "application/json" ,
           Authorization:`Basic ${basic.BASIC_AUTH_ADMIN}`,
           urn:urn,
           authToken:authToken,
          },
        body: JSON.stringify({ active: newActive }), 
      });

      const data = await res.json();

      if (!res.ok || data?.responseCode === 0) {
        setMsg(" Update failed.");
        return;
      }

      setMsg(`Tournament set to ${newActive === 1 ? "ACTIVE" : "INACTIVE"}`);
      sessionStorage.clear();
      await fetchTournaments();
      closePopup();
    } catch (err) {
      setMsg(" Something went wrong: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update-tournament-container">
      <h2 className="update-title">Update Tournament Status</h2>

      {loading && <p className="info-text">Loading...</p>}
      {msg && <p className="info-text">{msg}</p>}

      <div className="tournament-grid">
        {tournaments.map((t) => (
          <div
          key={t.tournamentID}
          className="tournament-card"
          onClick={() => handleSelect(t)}
          >
            <div className="t-card-top">
              <h3 className="t-card-title">{t.tournamentName}</h3>

              <span className={`status-badge ${t.tournamentStatus === 1 ? "on" : "off"}`}>
                {t.tournamentStatus === 1 ? "ACTIVE" : "INACTIVE"}
              </span>
            </div>

            <p className="t-card-date">{t.date}</p>
          </div>
        ))}
      </div>

      {selected && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-title">{selected.tournamentName}</h3>
            <p className="popup-date">{selected.date}</p>

            <p className="popup-status">
              Current Status:{" "}
              <b>{selected.tournamentStatus === 1 ? "ACTIVE " : "INACTIVE "}</b>
            </p>

            <div className="popup-actions">

              {selected.tournamentStatus===0 &&
              <button
                className="btn-active"
                disabled={loading}
                onClick={() => updateActiveStatus(1)}
              >Set Active</button>}

              {selected.tournamentStatus===1 &&
              <button
                className="btn-inactive"
                disabled={loading}
                onClick={() => updateActiveStatus(0)}
              >Set Inactive</button>}
      

            </div>

           
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateTournament;
